
<div class="content-section">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-div">
      <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
          <div class="col-11 p-0">
            <h2 class="background_title">{{ translationKeys.Dashboard.Dashboard | translate }}</h2>
          </div>
      </div>
    </div>

<div class="container-fluid">
    <!--  <lib-ph-bhp-dashboard></lib-ph-bhp-dashboard>-->
    <!-- TODO temporarily disabled until proper backend reimplementation -->
    <div class="container-fluid mt-4" *ngIf="roleId === 1 || roleId === 2">
        <div class="alert alert-warning w-100" role="alert">
            {{'DASHBOARD.TEMPORARILY_DISABLED' | translate}}
        </div>
    </div>
    <!-- TODO temporarily disabled until proper backend reimplementation-->
    <div (window:resize)="onResize()" *ngIf="roleId != 1 && roleId != 2">
        <div class="container-fluid dashboardDateControl pt-0 m-0">
            <div class="row justify-content-between align-items-center">
            </div>
                <div>
                    <div class="form-group" *ngIf="roleId != 1">
                        <div class="dropdown dropdown-bhp" *ngIf='showInstitutionDropDown()' style="width: 240px; min-width: 345px;">
                            <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                                <input class="dropdown-toggle" type="text" [ngModel]="layoutService.dashboardSelectedInstitutionName | translate" readonly />
                                <span class="label-dropdown">{{ 'SOP_MANAGEMENT.INSTITUTION' | translate }}</span>
                                <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                            </div>

                            <ul class="dropdown-menu">
                                <li value="0" class="dropdown-item" *ngIf="roleId != 3" [ngClass]=" selectedInstitutionName === 'All' ? 'active' : ''"
                                    (click)="onInstitutionChangeFront(0, 'SOP_MANAGEMENT.ALL'  )">{{ 'SOP_MANAGEMENT.ALL' | translate }}</li>
                                <li [value]="institution.institution.institution.institutionID" class="dropdown-item" *ngFor="let institution of institutionsList"
                                    (click)="onInstitutionChangeFront(institution.institution.institution.institutionID, institution.institution.institution.institutionName)"
                                    [ngClass]=" selectedInstitutionName === institution.institution.institution.institutionName ? 'active' : ''">
                                    {{ institution.institution.institution.institutionName | labelSanitizer }}
                                </li>
                            </ul>
                        </div>

                        <p *ngIf='!showInstitutionDropDown()' style="margin-bottom: 0px;line-height: 24px; ">{{ getInstitutionName() }}</p>
                    </div>
                </div>
                <div class="container-nav">
                    <nav class="nav nav-pills nav-title nav_padding pt-0" >
                        <a class="nav-link" [ngClass]="(tab == 'today')?'active':''" (click)="dateTab('today')">{{
                            translationKeys.Dashboard.Today | translate }}</a>
                        <a class="nav-link" [ngClass]="(tab == 'week')?'active':''" (click)="dateTab('week')">{{
                            'DASHBOARD.WEEK'
                            | translate }}</a>
                        <a class="nav-link" [ngClass]="(tab == 'month')?'active':''" (click)="dateTab('month')">{{
                            'CONFIGURE.MONTH' | translate }}</a>
                            </nav>
                   <hr class="w-100 mb-0 nav-separator">
                </div>
                </div>
        </div>

        <div class="container-fluid pt-0" *ngIf="roleId != 1 && roleId != 2">
            <div class="row">
                <div class="col-sm-6 col-md-3">
                    <div class=" card-dashboard cursor-default align-items-center d-flex">
                        <div class="col">
                            <span class="published">{{'INSTITUTION_MANAGEMENT.INSTITUTIONS' | translate }}</span>
                            <h5 class="mt-2 card-task-title">{{institutions}}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3" *ngIf="isSOP()">
                    <div class=" card-dashboard cursor-default align-items-center d-flex">
                        <div class="col my-auto">
                            <span class="published">{{'DASHBOARD.SOP_OBSERVATIONS' | translate}}</span>
                            <h5 class="mt-2 card-task-title">{{sopObservations}}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3" *ngIf="isDesktop && ( isObserve() )">
                    <div class=" card-dashboard cursor-default align-items-center d-flex">
                        <div class="col my-auto">
                            <span class="published">{{'DASHBOARD.Observe_observations' | translate}}</span>
                            <h5 class="mt-2 card-task-title">{{observeObservations}}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3">
                    <div class=" card-dashboard cursor-default align-items-center d-flex">
                        <div class="col my-auto">
                            <span class="published">{{'CONFIGURE.CONSUMPTION' | translate}}</span>
                            <h5 class="mt-2 card-task-title">{{consumptions}} <small>{{consumptionMeasurement |
                                    translate}}</small></h5>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row mt-4">
                <div class="col-sm-12 col-lg-6" *ngIf="roleId == 1 || roleId == 2">
                    <div class="col-12 static-card">
                        <h1 class="section-title">{{'AUTHORIZATION.PRODUCT_PACKAGE' | translate }}</h1>
                        <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <lib-ph-bhp-pie-chart #pieChart></lib-ph-bhp-pie-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-6" *ngIf="isSOP()">
                    <div class="col-12 static-card">
                        <h1 class="section-title">{{'DASHBOARD.TOP_5_SOP' | translate}}</h1>
                        <div class="row">
                            <div class="col-sm-12 col-md-12 table-responsive mt-3">
                                <table class="dashboard-table">
                                    <thead>
                                        <tr>
                                            <th>{{'DASHBOARD.SOP' | translate }}</th>
                                            <th><span>{{'DASHBOARD.OBSERVATIONS_N' | translate}}</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let sop of sopRoutines">
                                            <td>{{sop.sopName | translate}}</td>
                                            <td>{{sop.observationsCount}}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-6" *ngIf="isSOP()">
                    <div class="col-12 static-card">
                        <h1 class="section-title">{{'DASHBOARD.PROCESS_COMPLIANCE' | translate }}</h1>
                        <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <lib-ph-bhp-bar-chart #chart [isAdjustableHeight]="isAdjustableHeight"
                                    [isDesktop]='isDesktop' [dashboardReport]='true' [majorUnit]="25">
                                </lib-ph-bhp-bar-chart> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6" *ngIf="isDesktop && (isObserve() )">
                    <div class="col-12 static-card">
                        <h1 class="section-title">{{'DASHBOARD.OVERALL_COMPLIANCE' | translate}}</h1>
                        <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <lib-ph-bhp-bar-chart #chartOverall [dashboardReport]='true' [majorUnit]="25"></lib-ph-bhp-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6" *ngIf="isDesktop && (isObserve() )">
                    <div class="col-12 static-card">
                        <h1 class="section-title">{{ translationKeys.Dashboard.FiveMoments | translate}}</h1>
                        <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <lib-ph-bhp-bar-chart #chartMoments [isAdjustableHeight]="isAdjustableHeight"
                                    [isDesktop]='isDesktop' [dashboardReport]='true' [majorUnit]="25">
                                </lib-ph-bhp-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6"
                    *ngIf="isDesktop && isObserve() && (departmentList && departmentList.length)">
                    <div class="col-12 static-card">
                        <h1 class="section-title">{{'DASHBOARD.OBSERVATION_QUOTA' | translate}}</h1>
                        <div class="justify-content-end d-flex">
                            <div class="dropdown dropdown-bhp" >
                              <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                                  <input class="dropdown-toggle" type="text" [ngModel]="selectedDepartmentName | translate | labelSanitizer" readonly/>
                                  <span class="label-dropdown">{{ translationKeys.Configure.Department | translate }}</span>
                                  <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                              </div>
                              <ul class="dropdown-menu" >
                                  <li class="dropdown-item" *ngFor="let department of departmentList" [Value]="department" (click)="onDepartmentChange(department)" >{{department.departmentName | translate | labelSanitizer}}</li>
                              </ul>
                            </div>
                        </div>

                        <div *ngIf="!noQuotaData">
                            <span>{{ translationKeys.Dashboard.Progress | translate}}</span>
                            <span>{{progressQuotaCount}} {{ translationKeys.Dashboard.Opportunities | translate}}</span>
                        </div>
                        <div class="row" *ngIf="!noQuotaData">
                            <div class="col-sm-12 col-md-12">
                                <lib-ph-bhp-pie-chart #quotasChart></lib-ph-bhp-pie-chart>
                            </div>
                        </div>
                        <div class="row" *ngIf="noQuotaData">
                            <div class="col-sm-12 col-md-12">
                                {{ translationKeys.Dashboard.NoQuotasAssigned | translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
